import { TFunction } from 'i18next';
// @ts-ignore
import variables from 'styles/_variables.scss';
import { makeRange } from 'helpers';
import { IScaleRange } from 'modules/admin-panel/pages/results/models';

const { dangerColor, positiveColor, mediumColor } = variables;

export const generateHistogramColorsArray = (
	scaleRange?: IScaleRange,
): string[] => {
	if (!scaleRange) return [];
	const res = makeRange(scaleRange.positive.max);
	return res.map((i) => {
		if (i <= scaleRange.negative.max) {
			return dangerColor;
		}
		if (i >= scaleRange.positive.min) {
			return positiveColor;
		}
		return mediumColor;
	});
};

export const generateHistogramTooltipLabels = (scaleRange?: IScaleRange) => {
	if (!scaleRange) return [];
	const range = makeRange(scaleRange.positive.max, true);

	return range.reduce((res, i) => {
		let value;
		if (i < scaleRange.negative.max) {
			value = 'dissatisfied';
		} else if (i >= scaleRange.positive.min - 1) {
			value = 'satisfied';
		} else {
			value = 'neutral';
		}

		return {
			...res,
			[i]: value,
		};
	}, {});
};

export const generateLegendLabels = (t: TFunction) => () => {
	return [
		{
			text: t('service_rating_levels.negative'),
			fillStyle: dangerColor,
			pointStyle: 'rect' as 'rect',
		},
		{
			text: t('service_rating_levels.neutral'),
			fillStyle: mediumColor,
			pointStyle: 'rect' as 'rect',
		},
		{
			text: t('service_rating_levels.positive'),
			fillStyle: positiveColor,
			pointStyle: 'rect' as 'rect',
		},
	];
};
